export const APPROVAL_REVIEW_DAYS = 15
export const APPROVAL_REVIEW_MS = APPROVAL_REVIEW_DAYS * 24 * 60 * 60 * 1000

const validDate = value => {
  if (!value) return null
  const date = value instanceof Date ? new Date(value.getTime()) : new Date(value)
  return Number.isNaN(date.getTime()) ? null : date
}

// Admin presentation helper only. Endpoint authorization and provider
// cancellation continue to use the server evaluator/charge guard.
export const deriveAdminApprovalTiming = (item, now = new Date()) => {
  const user = item && item.for
  const everApproved = Boolean(user && (user.approved === true || user.firstApprovedAt != null))
  const startedAt = validDate(user && user.subscriptionStartedAt)
  if (!startedAt) {
    return {
      state: everApproved ? 'not-applicable' : 'not-started',
      startedAt: null,
      deadlineAt: null,
    }
  }

  const deadlineAt = new Date(startedAt.getTime() + APPROVAL_REVIEW_MS)
  if (everApproved) {
    return { state: 'not-applicable', startedAt, deadlineAt }
  }

  const evaluatedAt = validDate(now)
  if (!evaluatedAt) throw new TypeError('A valid evaluation time is required')
  return {
    state: evaluatedAt.getTime() < deadlineAt.getTime() ? 'active' : 'completed',
    startedAt,
    deadlineAt,
  }
}
